import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
import { getFacilityInfoList } from './FacilityCard.utils';
type Props = {
  className?: string;
  facility: FacilityEntity;
};
export const FacilityCard = ({ className, facility }: Props) => {
  if (!facility) {
    return null;
  }

  const { description, id, name, quantity, subTitle } = facility || {};
  const list = getFacilityInfoList(facility);
  return (
    <article className={classnames(className)} id={id}>
      <header className="mb-10">
        <Title hLevel={3} theme="title-brand-n4">
          {quantity} {name}
        </Title>
        {subTitle && <h4 className="text-14">{subTitle}</h4>}
      </header>
      <Text className="mb-10" text={description} theme="text-sans-n1" />
      {Boolean(list.length) && (
        <ul className="space-y-5 text-14">
          {list.map((l, index) => {
            const label = l.label || '';
            return (
              <li key={label + '-' + index}>
                {label && <span className="font-bold">{label} </span>}
                {l.value}
              </li>
            );
          })}
        </ul>
      )}
    </article>
  );
};
